// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Message - Ethereal Tech Design
 *
 * Features gradient user bubbles, refined markdown styling,
 * subtle metadata, and smooth entrance animations.
 */

.message {
  display: flex;
  flex-direction: column;
  animation: message-enter 0.4s var(--ease-out-expo);
  animation-fill-mode: both;
}

@keyframes message-enter {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== User Messages ===== */
.message-user {
  align-self: flex-end;
  max-width: 75%;
}

.message-user .message-content {
  position: relative;
  background: var(--message-user-bg);
  color: var(--message-user-text);
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--radius-xl) var(--radius-xl) var(--radius-sm) var(--radius-xl);
  border: 1px solid var(--message-user-border);
  backdrop-filter: blur(var(--blur-sm));
  -webkit-backdrop-filter: blur(var(--blur-sm));
}

.message-user .message-content::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, transparent 50%);
  pointer-events: none;
}

/* ===== Participant Messages (all bots in group chat) ===== */
.message-participant {
  align-self: flex-start;
  max-width: 100%;
}

.message-participant .message-content {
  background: transparent;
  color: var(--text-secondary);
  padding: var(--spacing-md) 0;
  border-left: 2px solid var(--participant-color, var(--color-accent));
  padding-left: var(--spacing-md);
  margin-left: var(--spacing-xs);
}

.message-participant .message-markdown {
  color: var(--text-primary);
}

.message-participant .message-role {
  color: var(--participant-color, var(--color-accent));
}

.participant-content {
  font-size: var(--font-size-sm);
  font-family: var(--font-family-mono);
}

.participant-action {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.participant-action-text {
  color: var(--text-secondary);
}

.participant-detail-toggle {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 0 var(--spacing-xs);
  font-size: var(--font-size-sm);
  line-height: 1;
  transition: color var(--transition-fast);
}

.participant-detail-toggle:hover {
  color: var(--text-secondary);
}

.participant-result {
  margin: var(--spacing-sm) 0 0 0;
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--glass-border);
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
  overflow-x: auto;
  max-height: 200px;
  overflow-y: auto;
}

/* ===== Error Messages ===== */
.message-error .message-content {
  background: linear-gradient(135deg, rgba(248, 113, 113, 0.15), rgba(239, 68, 68, 0.1));
  border: 1px solid rgba(248, 113, 113, 0.3);
  color: var(--color-error);
}

/* ===== Message Header ===== */
.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--spacing-sm);
  padding: 0 var(--spacing-xs);
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.message-user .message-header {
  padding-right: var(--spacing-sm);
}

.message-role {
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-wide);
  text-transform: uppercase;
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
}

.message-role-type {
  font-weight: normal;
  text-transform: none;
  letter-spacing: normal;
  opacity: 0.7;
  font-size: 10px;
}

.message-time {
  font-size: var(--font-size-xs);
  color: var(--text-dim);
}

/* ===== Message Content ===== */
.message-content {
  line-height: var(--line-height-relaxed);
  font-size: var(--font-size-base);
}

.message-text {
  margin: 0;
  word-wrap: break-word;
  white-space: pre-wrap;
}

/* ===== Markdown Styling ===== */
.message-markdown {
  white-space: normal;
}

.message-markdown p {
  margin: 0 0 var(--spacing-md) 0;
  line-height: var(--line-height-relaxed);
}

.message-markdown p:last-child {
  margin-bottom: 0;
}

.message-markdown h1,
.message-markdown h2,
.message-markdown h3,
.message-markdown h4 {
  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-tight);
  color: var(--text-primary);
}

.message-markdown h1 {
  font-size: var(--font-size-2xl);
}
.message-markdown h2 {
  font-size: var(--font-size-xl);
}
.message-markdown h3 {
  font-size: var(--font-size-lg);
}
.message-markdown h4 {
  font-size: var(--font-size-base);
}

.message-markdown h1:first-child,
.message-markdown h2:first-child,
.message-markdown h3:first-child,
.message-markdown h4:first-child {
  margin-top: 0;
}

/* Lists */
.message-markdown ul,
.message-markdown ol {
  margin: var(--spacing-md) 0;
  padding-left: var(--spacing-lg);
}

.message-markdown li {
  margin-bottom: var(--spacing-sm);
  line-height: var(--line-height-relaxed);
}

.message-markdown li:last-child {
  margin-bottom: 0;
}

.message-markdown li::marker {
  color: var(--color-primary);
}

/* Inline Code */
.message-markdown code {
  font-family: var(--font-family-mono);
  font-size: 0.9em;
  background: var(--bg-tertiary);
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--glass-border);
  color: var(--color-accent);
}

/* Code Blocks */
.message-markdown pre {
  position: relative;
  background: var(--bg-secondary);
  padding: var(--spacing-lg);
  border-radius: var(--radius-lg);
  overflow-x: auto;
  margin: var(--spacing-lg) 0;
  border: 1px solid var(--glass-border);
}

.message-markdown pre::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 32px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, transparent 100%);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  pointer-events: none;
}

.message-markdown pre code {
  background: transparent;
  padding: 0;
  border: none;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  color: var(--text-primary);
}

/* Blockquotes */
.message-markdown blockquote {
  position: relative;
  margin: var(--spacing-md) 0;
  padding: var(--spacing-md) var(--spacing-lg);
  background: var(--glass-bg);
  border-left: 3px solid var(--color-primary);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  color: var(--text-secondary);
  font-style: italic;
}

/* Links */
.message-markdown a {
  color: var(--color-accent);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: all var(--transition-fast);
}

.message-markdown a:hover {
  color: var(--color-accent-hover);
  border-bottom-color: var(--color-accent);
}

/* Tables */
.message-markdown table {
  width: 100%;
  border-collapse: collapse;
  margin: var(--spacing-md) 0;
  font-size: var(--font-size-sm);
}

.message-markdown th,
.message-markdown td {
  border: 1px solid var(--glass-border);
  padding: var(--spacing-sm) var(--spacing-md);
  text-align: left;
}

.message-markdown th {
  background: var(--bg-tertiary);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.message-markdown tr:nth-child(even) {
  background: var(--glass-bg);
}

/* Horizontal Rule */
.message-markdown hr {
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--glass-border), transparent);
  margin: var(--spacing-xl) 0;
}

/* Strong & Em */
.message-markdown strong {
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.message-markdown em {
  font-style: italic;
  color: var(--text-secondary);
}

/* ===== Message Metadata ===== */
.message-metadata {
  margin-top: var(--spacing-sm);
  font-size: var(--font-size-xs);
  font-family: var(--font-family-mono);
  color: var(--text-dim);
  opacity: 0.6;
  letter-spacing: var(--letter-spacing-wide);
  transition: opacity var(--transition-fast);
  cursor: default;
}

.message-metadata:hover {
  opacity: 1;
  color: var(--text-tertiary);
}

/* ===== Generating Indicator ===== */
.message-generating {
  margin-top: var(--spacing-sm);
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
  letter-spacing: var(--letter-spacing-wide);
}

.generating-dots::after {
  content: "";
  animation: generating-dots 1.5s steps(4, end) infinite;
}

@keyframes generating-dots {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "";
  }
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .message-user {
    max-width: 85%;
  }

  .message-user .message-content {
    padding: var(--spacing-sm) var(--spacing-md);
  }

  .message-content {
    font-size: var(--font-size-sm);
  }

  .message-markdown pre {
    padding: var(--spacing-md);
    font-size: var(--font-size-xs);
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/Message.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,4CAA4C;EAC5C,kFAAkF;EAClF,4CAA4C;EAC5C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,oEAAoE;EACpE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,sFAAsF;EACtF,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,+CAA+C;EAC/C,wCAAwC;EACxC,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA,UAAU;AACV;;EAEE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mFAAmF;EACnF,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4CAA4C;EAC5C,2BAA2B;EAC3B,2CAA2C;EAC3C,oDAAoD;EACpD,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,WAAW;EACX,iFAAiF;EACjF,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,sDAAsD;AACxD;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF","sourcesContent":["/**\n * Message - Ethereal Tech Design\n *\n * Features gradient user bubbles, refined markdown styling,\n * subtle metadata, and smooth entrance animations.\n */\n\n@import \"../styles/variables.css\";\n\n.message {\n  display: flex;\n  flex-direction: column;\n  animation: message-enter 0.4s var(--ease-out-expo);\n  animation-fill-mode: both;\n}\n\n@keyframes message-enter {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== User Messages ===== */\n.message-user {\n  align-self: flex-end;\n  max-width: 75%;\n}\n\n.message-user .message-content {\n  position: relative;\n  background: var(--message-user-bg);\n  color: var(--message-user-text);\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--radius-xl) var(--radius-xl) var(--radius-sm) var(--radius-xl);\n  border: 1px solid var(--message-user-border);\n  backdrop-filter: blur(var(--blur-sm));\n  -webkit-backdrop-filter: blur(var(--blur-sm));\n}\n\n.message-user .message-content::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n/* ===== Participant Messages (all bots in group chat) ===== */\n.message-participant {\n  align-self: flex-start;\n  max-width: 100%;\n}\n\n.message-participant .message-content {\n  background: transparent;\n  color: var(--text-secondary);\n  padding: var(--spacing-md) 0;\n  border-left: 2px solid var(--participant-color, var(--color-accent));\n  padding-left: var(--spacing-md);\n  margin-left: var(--spacing-xs);\n}\n\n.message-participant .message-markdown {\n  color: var(--text-primary);\n}\n\n.message-participant .message-role {\n  color: var(--participant-color, var(--color-accent));\n}\n\n.participant-content {\n  font-size: var(--font-size-sm);\n  font-family: var(--font-family-mono);\n}\n\n.participant-action {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.participant-action-text {\n  color: var(--text-secondary);\n}\n\n.participant-detail-toggle {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 0 var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  line-height: 1;\n  transition: color var(--transition-fast);\n}\n\n.participant-detail-toggle:hover {\n  color: var(--text-secondary);\n}\n\n.participant-result {\n  margin: var(--spacing-sm) 0 0 0;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--glass-border);\n  font-size: var(--font-size-xs);\n  color: var(--text-secondary);\n  overflow-x: auto;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* ===== Error Messages ===== */\n.message-error .message-content {\n  background: linear-gradient(135deg, rgba(248, 113, 113, 0.15), rgba(239, 68, 68, 0.1));\n  border: 1px solid rgba(248, 113, 113, 0.3);\n  color: var(--color-error);\n}\n\n/* ===== Message Header ===== */\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--spacing-sm);\n  padding: 0 var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n.message-user .message-header {\n  padding-right: var(--spacing-sm);\n}\n\n.message-role {\n  font-weight: var(--font-weight-medium);\n  letter-spacing: var(--letter-spacing-wide);\n  text-transform: uppercase;\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n}\n\n.message-role-type {\n  font-weight: normal;\n  text-transform: none;\n  letter-spacing: normal;\n  opacity: 0.7;\n  font-size: 10px;\n}\n\n.message-time {\n  font-size: var(--font-size-xs);\n  color: var(--text-dim);\n}\n\n/* ===== Message Content ===== */\n.message-content {\n  line-height: var(--line-height-relaxed);\n  font-size: var(--font-size-base);\n}\n\n.message-text {\n  margin: 0;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n/* ===== Markdown Styling ===== */\n.message-markdown {\n  white-space: normal;\n}\n\n.message-markdown p {\n  margin: 0 0 var(--spacing-md) 0;\n  line-height: var(--line-height-relaxed);\n}\n\n.message-markdown p:last-child {\n  margin-bottom: 0;\n}\n\n.message-markdown h1,\n.message-markdown h2,\n.message-markdown h3,\n.message-markdown h4 {\n  margin: var(--spacing-lg) 0 var(--spacing-sm) 0;\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--letter-spacing-tight);\n  color: var(--text-primary);\n}\n\n.message-markdown h1 {\n  font-size: var(--font-size-2xl);\n}\n.message-markdown h2 {\n  font-size: var(--font-size-xl);\n}\n.message-markdown h3 {\n  font-size: var(--font-size-lg);\n}\n.message-markdown h4 {\n  font-size: var(--font-size-base);\n}\n\n.message-markdown h1:first-child,\n.message-markdown h2:first-child,\n.message-markdown h3:first-child,\n.message-markdown h4:first-child {\n  margin-top: 0;\n}\n\n/* Lists */\n.message-markdown ul,\n.message-markdown ol {\n  margin: var(--spacing-md) 0;\n  padding-left: var(--spacing-lg);\n}\n\n.message-markdown li {\n  margin-bottom: var(--spacing-sm);\n  line-height: var(--line-height-relaxed);\n}\n\n.message-markdown li:last-child {\n  margin-bottom: 0;\n}\n\n.message-markdown li::marker {\n  color: var(--color-primary);\n}\n\n/* Inline Code */\n.message-markdown code {\n  font-family: var(--font-family-mono);\n  font-size: 0.9em;\n  background: var(--bg-tertiary);\n  padding: 3px 8px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--glass-border);\n  color: var(--color-accent);\n}\n\n/* Code Blocks */\n.message-markdown pre {\n  position: relative;\n  background: var(--bg-secondary);\n  padding: var(--spacing-lg);\n  border-radius: var(--radius-lg);\n  overflow-x: auto;\n  margin: var(--spacing-lg) 0;\n  border: 1px solid var(--glass-border);\n}\n\n.message-markdown pre::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, transparent 100%);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  pointer-events: none;\n}\n\n.message-markdown pre code {\n  background: transparent;\n  padding: 0;\n  border: none;\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-normal);\n  color: var(--text-primary);\n}\n\n/* Blockquotes */\n.message-markdown blockquote {\n  position: relative;\n  margin: var(--spacing-md) 0;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: var(--glass-bg);\n  border-left: 3px solid var(--color-primary);\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n/* Links */\n.message-markdown a {\n  color: var(--color-accent);\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: all var(--transition-fast);\n}\n\n.message-markdown a:hover {\n  color: var(--color-accent-hover);\n  border-bottom-color: var(--color-accent);\n}\n\n/* Tables */\n.message-markdown table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: var(--spacing-md) 0;\n  font-size: var(--font-size-sm);\n}\n\n.message-markdown th,\n.message-markdown td {\n  border: 1px solid var(--glass-border);\n  padding: var(--spacing-sm) var(--spacing-md);\n  text-align: left;\n}\n\n.message-markdown th {\n  background: var(--bg-tertiary);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.message-markdown tr:nth-child(even) {\n  background: var(--glass-bg);\n}\n\n/* Horizontal Rule */\n.message-markdown hr {\n  border: none;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--glass-border), transparent);\n  margin: var(--spacing-xl) 0;\n}\n\n/* Strong & Em */\n.message-markdown strong {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.message-markdown em {\n  font-style: italic;\n  color: var(--text-secondary);\n}\n\n/* ===== Message Metadata ===== */\n.message-metadata {\n  margin-top: var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  font-family: var(--font-family-mono);\n  color: var(--text-dim);\n  opacity: 0.6;\n  letter-spacing: var(--letter-spacing-wide);\n  transition: opacity var(--transition-fast);\n  cursor: default;\n}\n\n.message-metadata:hover {\n  opacity: 1;\n  color: var(--text-tertiary);\n}\n\n/* ===== Generating Indicator ===== */\n.message-generating {\n  margin-top: var(--spacing-sm);\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n  letter-spacing: var(--letter-spacing-wide);\n}\n\n.generating-dots::after {\n  content: \"\";\n  animation: generating-dots 1.5s steps(4, end) infinite;\n}\n\n@keyframes generating-dots {\n  0% {\n    content: \"\";\n  }\n  25% {\n    content: \".\";\n  }\n  50% {\n    content: \"..\";\n  }\n  75% {\n    content: \"...\";\n  }\n  100% {\n    content: \"\";\n  }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .message-user {\n    max-width: 85%;\n  }\n\n  .message-user .message-content {\n    padding: var(--spacing-sm) var(--spacing-md);\n  }\n\n  .message-content {\n    font-size: var(--font-size-sm);\n  }\n\n  .message-markdown pre {\n    padding: var(--spacing-md);\n    font-size: var(--font-size-xs);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
